import { useEffect, useState } from 'react';
import { readTtsVolume, writeTtsVolume } from './preferences.js';

export interface UseTtsVolumeReturn {
  volume: number;
  setVolume: (v: number) => void;
  /** Aplica un delta relativo (-1..+1). Útil para gestos. */
  adjustVolume: (delta: number) => void;
}

export function useTtsVolume(): UseTtsVolumeReturn {
  const [volume, setVolumeState] = useState<number>(() => readTtsVolume());

  useEffect(() => {
    const onChange = (e: Event): void => {
      const detail = (e as CustomEvent<number>).detail;
      if (typeof detail === 'number') setVolumeState(detail);
    };
    window.addEventListener('orborix:pref.ttsVolume', onChange);
    return () => window.removeEventListener('orborix:pref.ttsVolume', onChange);
  }, []);

  const setVolume = (v: number): void => {
    const clamped = Math.min(1, Math.max(0, v));
    writeTtsVolume(clamped);
    setVolumeState(clamped);
  };
  const adjustVolume = (delta: number): void => {
    setVolume(volume + delta);
  };

  return { volume, setVolume, adjustVolume };
}
